<template>
  <div>
    <el-dialog
      class="process-mind-map-dialog process-mind-map-source-dialog fishbone-form-detail-dialog order-audit-list-dialog"
      v-dialogDrag
      :visible.sync="innerVisible"
      width="96vw"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @open="loadData"
      @closed="resetData">
      <div slot="title" class="order-audit-dialog__title">
        <span>{{ $LANG('', '订单评审表') }}</span>
      </div>
      <div class="order-audit-dialog__body">
        <div class="order-audit-dialog__toolbar">
          <el-button
            class="order-audit-dialog__add"
            type="primary"
            size="mini"
            icon="iconfont icon-xinzeng"
            :disabled="addBool"
            @click="addRecord">
            {{ $LANG('0138', '新增') }}
          </el-button>
        </div>
        <el-table
          :data="tableData"
          border
          size="small"
          ref="listTable"
          class="custom-table-border order-audit-dialog__table"
          v-loading="loading"
          :element-loading-text="$LANG('1959', '加载中')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 251, 255, 0.8)"
          show-summary
          :summary-method="getSummary"
          :cell-style="{ padding: '2px' }"
          :header-cell-style="headStyle"
          cell-class-name="clearPadding2"
          height="calc(88vh - 97px)"
          highlight-current-row>
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed></el-table-column>
          <el-table-column
            v-for="item in visibleColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
            :min-width="item.width">
            <template slot-scope="scope">
              <el-checkbox
                v-if="item.edcss === 'checkbox'"
                disabled
                true-label="Y"
                false-label="N"
                v-model="scope.row[item.key]">
              </el-checkbox>
              <el-link v-else-if="item.key === 'IDNO'" :underline="false" @click="openDetail(scope.row, 'view')">
                <span class="order-audit-dialog__idno">{{ displayText(scope.row[item.key]) }}</span>
              </el-link>
              <el-tag
                v-else-if="item.key === 'STFG'"
                size="mini"
                :type="getStatusTagType(scope.row[item.key])"
                effect="dark">
                {{ getStatusTextForRow(scope.row) }}
              </el-tag>
              <el-tag
                v-else-if="isYesNoField(item)"
                size="mini"
                :type="scope.row[item.key] === 'Y' ? 'success' : 'info'"
                effect="dark">
                {{ scope.row[item.key] === 'Y' ? $LANG('2047', '是') : $LANG('2044', '否') }}
              </el-tag>
              <span v-else v-text="displayText(scope.row[item.key])"></span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$LANG('0330', '操作')"
            align="center"
            width="132">
            <template slot-scope="scope">
              <div class="order-audit-dialog__action-group">
                <el-tooltip :content="$LANG('0139', '查看')" placement="top" effect="light">
                  <el-button
                    class="order-audit-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-chakan"
                    :aria-label="$LANG('0139', '查看')"
                    @click="openDetail(scope.row, 'view')">
                  </el-button>
                </el-tooltip>
                <template v-if="scope.row.STFG === 'N'">
                  <el-tooltip v-if="!editBool" :content="$LANG('1639', '编辑')" placement="top" effect="light">
                    <el-button
                      class="order-audit-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-bianji"
                      :aria-label="$LANG('1639', '编辑')"
                      @click="openDetail(scope.row, 'edit')">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="order-audit-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-bianji"
                    disabled
                    :aria-label="$LANG('1639', '编辑')">
                  </el-button>
                  <el-tooltip v-if="!appBool" :content="$LANG('0364', '确认')" placement="top" effect="light">
                    <el-button
                      class="order-audit-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-shenhe"
                      :aria-label="$LANG('0364', '确认')"
                      @click="setStatus(scope.row, 'K', $LANG('0364', '确认'))">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="order-audit-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-shenhe"
                    disabled
                    :aria-label="$LANG('0364', '确认')">
                  </el-button>
                </template>
                <template v-else-if="scope.row.STFG === 'K'">
                  <el-tooltip v-if="!appBool" :content="$LANG('0314', '弃认')" placement="top" effect="light">
                    <el-button
                      class="order-audit-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-fanshenhe"
                      :aria-label="$LANG('0314', '弃认')"
                      @click="setStatus(scope.row, 'N', $LANG('0314', '弃认'))">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="order-audit-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-fanshenhe"
                    disabled
                    :aria-label="$LANG('0314', '弃认')">
                  </el-button>
                  <el-tooltip v-if="!cfmBool" :content="$LANG('0134', '审核')" placement="top" effect="light">
                    <el-button
                      class="order-audit-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-shenhe"
                      :aria-label="$LANG('0134', '审核')"
                      @click="setStatus(scope.row, 'Y', $LANG('0134', '审核'))">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="order-audit-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-shenhe"
                    disabled
                    :aria-label="$LANG('0134', '审核')">
                  </el-button>
                </template>
                <template v-else-if="scope.row.STFG === 'Y'">
                  <el-tooltip v-if="!cfmBool" :content="$LANG('0137', '弃审')" placement="top" effect="light">
                    <el-button
                      class="order-audit-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-fanshenhe"
                      :aria-label="$LANG('0137', '弃审')"
                      @click="setStatus(scope.row, 'K', $LANG('0137', '弃审'))">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="order-audit-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-fanshenhe"
                    disabled
                    :aria-label="$LANG('0137', '弃审')">
                  </el-button>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      class="process-mind-map-dialog order-audit-detail-dialog"
      v-dialogDrag
      :visible.sync="detailVisible"
      :width="dialogWidth"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="resetDetailData">
      <div slot="title" class="order-audit-dialog__title">
        <span>{{ detailMode === 'create' ? $LANG('0095', '新增记录') : (detailMode === 'edit' ? $LANG('0921', '编辑记录') : $LANG('0971', '资料明细')) }}</span>
      </div>
      <div class="order-audit-detail-dialog__body" v-loading="detailLoading">
        <div v-for="(gpitem, gpind) in formGroups" :key="gpind">
          <div class="process-dialog-section order-audit-detail-dialog__section">
            <span>{{ gpitem.gpnm }}</span>
          </div>
          <Form class="order-audit-detail-dialog__form" :model="mainRow" :label-width="getGroupLabelWidth(gpitem)" label-position="right" inline>
            <template v-for="(item, index) in gpitem.gplist">
              <div
                v-if="isVisibleFormField(item)"
                :key="index"
                :class="getMainFormCellClass(item)">
                <FormItem
                  :class="isTextareaField(item) ? 'order-audit-detail-dialog__form-item order-audit-detail-dialog__form-item--wide order-audit-detail-dialog__form-item--textarea' : 'order-audit-detail-dialog__form-item'"
                  :prop="item.fldno">
                  <template slot="label"><span v-if="item.notnull === 'Y'" class="order-audit-detail-dialog__required">*</span>{{ item.title }}</template>
                  <el-select
                    v-if="item.key === 'FRUSER'"
                    size="medium"
                    :disabled="isMainFieldDisabled(item)"
                    filterable
                    :placeholder="$LANG('1664', '请选择')"
                    v-model="mainRow[item.fldno]"
                    style="width:100%">
                    <el-option
                      v-for="(option, optIndex) in empArr"
                      :key="optIndex"
                      :disabled="option.STFG === 'X'"
                      :label="option.USERNM"
                      :value="option.USERNM">
                    </el-option>
                  </el-select>
                  <el-date-picker
                    size="medium"
                    :disabled="isMainFieldDisabled(item)"
                    type="date"
                    v-else-if="item.edcss === 'date'"
                    v-model="mainRow[item.fldno]"
                    clearable
                    value-format="yyyy-MM-dd"
                    style="width:100%">
                  </el-date-picker>
                  <el-input-number
                    size="medium"
                    :precision="item.dotnum"
                    :disabled="isMainFieldDisabled(item)"
                    v-else-if="item.edcss === 'number'"
                    v-model="mainRow[item.fldno]"
                    style="width:100%">
                  </el-input-number>
                  <el-checkbox
                    size="medium"
                    border
                    :disabled="isMainFieldDisabled(item)"
                    v-else-if="item.edcss === 'checkbox'"
                    true-label="Y"
                    false-label="N"
                    v-model="mainRow[item.fldno]"
                    style="width:100%">
                  </el-checkbox>
                  <el-select
                    size="medium"
                    :disabled="isMainFieldDisabled(item)"
                    filterable
                    v-else-if="item.edcss === 'select'"
                    v-model="mainRow[item.fldno]"
                    style="width:100%">
                    <el-option
                      v-for="(option, optIndex) in comboArr[item.fldno] || []"
                      :key="optIndex"
                      :label="option.CNAME"
                      :value="option.CNAME">
                    </el-option>
                  </el-select>
                  <el-input
                    size="medium"
                    :disabled="isMainFieldDisabled(item)"
                    v-else-if="item.edcss === 'button'"
                    v-model="mainRow[item.fldno]"
                    @focus="inputBtn(item.key)"
                    style="width:100%">
                  </el-input>
                  <el-input
                    size="medium"
                    :disabled="isMainFieldDisabled(item)"
                    v-else-if="isTextareaField(item)"
                    resize="none"
                    type="textarea"
                    :rows="4"
                    v-model="mainRow[item.fldno]">
                  </el-input>
                  <el-input
                    size="medium"
                    :placeholder="item.holder"
                    :disabled="isMainFieldDisabled(item)"
                    v-else
                    v-model="mainRow[item.fldno]">
                  </el-input>
                </FormItem>
              </div>
            </template>
          </Form>
        </div>
        <div class="process-dialog-section order-audit-detail-dialog__section order-audit-detail-dialog__section--attachment">
          <span>{{ $LANG('0516', '上传附件') }}</span>
        </div>
        <div class="order-audit-detail-dialog__attachment-row" :class="{ 'order-audit-detail-dialog__attachment-row--empty-view': detailMode === 'view' && !imgData.length && !detailLoading }">
          <Upload
            v-if="detailMode !== 'view'"
            ref="upload"
            name="upfile"
            :data="uploadData"
            :show-upload-list="false"
            :before-upload="beforeImgFile"
            :on-success="successImgFile"
            :with-credentials="true" 
            :format="['jpg','jpeg','png','pdf']"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            type="drag"
            :disabled="saveFlag"
            :on-progress="handleProgress"
            :action="uploadUrl"
            class="order-audit-detail-dialog__uploader">
            <div class="order-audit-detail-dialog__upload-inner">
              <el-image src="/assets/basedict/nopic.png" class="order-audit-detail-dialog__upload-img"></el-image>
              <p>{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
            </div>
          </Upload>
          <div class="order-audit-detail-dialog__attachment-list" :class="{ 'order-audit-detail-dialog__attachment-list--empty-view': detailMode === 'view' && !imgData.length && !detailLoading }">
            <div v-for="(item, index) in imgData" :key="index" class="order-audit-detail-dialog__attachment-card">
              <div v-if="isPdfFile(item.FILEPATH)" class="order-audit-detail-dialog__pdf-frame">
                <iframe :src="item.FILEPATH" frameborder="0"></iframe>
              </div>
              <el-image
                v-else
                :preview-src-list="[item.FILEPATH]"
                fit="fill"
                class="order-audit-detail-dialog__attachment-img"
                :src="item.FILEPATH">
              </el-image>
              <div class="order-audit-detail-dialog__attachment-actions">
                <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item.IDSEQ, item.LSTSEQ, item.FILEPATH, index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                <el-link v-if="isPdfFile(item.FILEPATH)" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
              </div>
            </div>
            <div v-if="detailMode === 'view' && !imgData.length && !detailLoading" class="order-audit-detail-dialog__empty">{{ $LANG('', '暂无附件') }}</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="order-audit-dialog__footer">
        <span class="order-audit-detail-dialog__status">
          <i v-if="mainRow.STFG === 'N'" class="iconfont icon-weishenhe3"></i>
          <i v-else-if="mainRow.STFG === 'K'" class="iconfont icon-yiqueren-xianxing"></i>
          <i v-else-if="mainRow.STFG === 'Y'" class="iconfont icon-yishenhe1"></i>
          <i v-else-if="mainRow.STFG === 'X'" class="iconfont icon-yizuofei"></i>
        </span>
        <el-button type="info" size="small" icon="iconfont icon-shanchu" @click="detailVisible = false">{{ $LANG('0132', '取消') }}</el-button>
        <el-button
          v-if="detailMode !== 'view'"
          :disabled="saveFlag || saving || (detailMode === 'create' ? addBool : editBool)"
          :loading="saving"
          size="small"
          type="primary"
          icon="iconfont icon-baocun"
          @click="saveDetail">
          {{ $LANG('0130', '保存') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="process-mind-map-dialog order-audit-select-dialog"
      v-dialogDrag
      :visible.sync="selectVisible"
      :width="dialogWidth"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div slot="title" class="order-audit-dialog__title">
        <span>{{ $LANG('0997', '选择记录') }}</span>
      </div>
      <div class="order-audit-select-dialog__body">
        <div class="order-audit-select-dialog__toolbar">
          <span class="order-audit-select-dialog__label">{{ $LANG('0681', '字段查询') }}</span>
          <el-select
            v-model="selectParam"
            :placeholder="$LANG('1675', '请选择列名')"
            filterable
            size="small"
            class="order-audit-select-dialog__field">
            <el-option
              v-for="item in selectVisibleColumns"
              :key="item.key"
              :label="item.title"
              :value="item.key">
            </el-option>
          </el-select>
          <el-select v-model="selectOper" size="small" class="order-audit-select-dialog__oper">
            <el-option
              v-for="item in operArr"
              :key="item.IDSEQ"
              :label="item.CNAME"
              :value="item.SUBNO">
            </el-option>
          </el-select>
          <el-input
            :placeholder="$LANG('1692', '请输入查询值')"
            clearable
            ref="selectQueryInput"
            v-model="selectText"
            @keyup.enter.native="querySelectRows"
            size="small"
            class="order-audit-select-dialog__input">
            <el-button size="small" slot="append" icon="el-icon-search" @click="querySelectRows"></el-button>
          </el-input>
          <div class="order-audit-select-dialog__actions">
            <el-button type="primary" size="small" icon="iconfont icon-yiqueren-xianxing" @click="confirmSelectRow">{{ $LANG('1638', '确定') }}</el-button>
            <el-button type="info" size="small" icon="iconfont icon-shanchu" @click="selectVisible = false">{{ $LANG('0132', '取消') }}</el-button>
          </div>
        </div>
        <el-table
          :data="selectPageRows"
          border
          size="small"
          ref="selectTableRef"
          class="custom-table-border order-audit-select-dialog__table"
          v-loading="selectLoading"
          :element-loading-text="$LANG('1959', '加载中')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 251, 255, 0.8)"
          height="calc(82vh - 88px)"
          highlight-current-row
          @row-click="selectRowClick">
          <el-table-column
            v-for="item in selectVisibleColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
            :min-width="item.width">
          </el-table-column>
        </el-table>
        <div class="order-audit-select-dialog__pager">
          <Page :total="selectDataCount" :page-size="selectRowSize" show-total :current="selectCurrent" @on-change="changeSelectPage"></Page>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
      <div slot="title" class="order-audit-upload-progress__title">
        <span>{{ $LANG('2052', '正在上传中...') }}</span>
      </div>
      <el-progress type="circle" :percentage="videoUploadPercent"></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import { getBaseData, getTabColOrData } from '../../api/user'
import { getDate } from '../../api/Select'

export default {
  name: 'OrderAuditDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      default: function () { return null }
    },
    corpid: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      loading: false,
      detailLoading: false,
      saving: false,
      detailVisible: false,
      detailMode: 'view',
      saveFlag: true,
      columns: [],
      tableData: [],
      formGroups: [],
      requiredFields: [],
      mainRow: {},
      comboArr: {},
      empArr: [],
      prodColumns: [],
      empColumns: [],
      imgData: [],
      delImg: [],
      uploadData: {},
      videoFlag: false,
      videoUploadPercent: 0,
      fileName: '',
      Accept: 'png,jpg,jpeg,gif,tiff,pdf',
      uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
      selectVisible: false,
      selectColumns: [],
      selectTable: '',
      selectKey2: '',
      selectValue2: '',
      selectUseCorpid: true,
      selectParam: '',
      selectText: '',
      selectOper: 'like',
      selectLoading: false,
      selectSelectedRow: {},
      selectRows: [],
      selectPageRows: [],
      selectDataCount: 0,
      selectCurrent: 1,
      selectRowSize: 50,
      selectKey: '',
      operArr: [],
      addBool: false,
      editBool: false,
      cfmBool: false,
      appBool: false
    }
  },
  computed: {
    innerVisible: {
      get: function () { return this.visible },
      set: function (value) { this.$emit('update:visible', value) }
    },
    dialogWidth: function () {
      return (window.innerWidth - 140) + 'px'
    },
    visibleColumns: function () {
      return this.columns.filter(function (item) { return item.thide === 'N' })
    },
    selectVisibleColumns: function () {
      return this.selectColumns.filter(function (item) { return item.thide === 'N' && item.key !== 'SEL' })
    },
    vUsername: function () {
      return this.$cookies.get('v_telno')
    },
 
    vUsernm: function () {
      return this.$cookies.get('v_usernm')
    },
    vAdmin: function () {
      return this.$cookies.get('v_admin')
    },
    vCorpid: function () {
      return (this.getNodeData() && this.getNodeData().CORPID) || this.corpid || this.$cookies.get('v_corpid')
    },
    nodeCorpid: function () {
      return (this.getNodeData() && this.getNodeData().CORPID) || ''
    },
    tableUrl: function () {
      return  'xuper_auth/getTableRecMany'
    },
    formGroupUrl: function () {
      return  'xuper_auth/getFormGroup'
    },
    noauthUrl: function () {
      return  'xuper_auth/getBaseData'
    }
  },
  methods: {
    resetData: function () {
      this.loading = false
      this.columns = []
      this.tableData = []
      this.detailVisible = false
      this.selectVisible = false
      this.resetDetailData()
    },
    resetDetailData: function () {
      this.detailLoading = false
      this.saving = false
      this.detailMode = 'view'
      this.saveFlag = true
      this.formGroups = []
      this.requiredFields = []
      this.comboArr = {}
      this.mainRow = {}
      this.imgData = []
      this.delImg = []
      this.uploadData = {}
      this.videoFlag = false
      this.videoUploadPercent = 0
      this.fileName = ''
      this.selectColumns = []
      this.selectTable = ''
      this.selectKey2 = ''
      this.selectValue2 = ''
      this.selectUseCorpid = true
      this.selectSelectedRow = {}
      this.selectRows = []
      this.selectPageRows = []
      this.selectDataCount = 0
      this.selectCurrent = 1
      this.selectKey = ''
    },
    loadData: function () {
      this.loading = true
      Promise.all([
        this.loadListColumns(),
        this.loadRows(),
        this.loadPermission(),
        this.loadRequiredFields(),
        this.loadEmployeeRows(),
        this.loadProdColumns(),
        this.loadEmpColumns(),
        this.loadOperRows()
      ]).then(function (result) {
        this.columns = result[0] || []
        this.tableData = result[1] || []
        this.requiredFields = result[3] || []
        this.empArr = result[4] || []
        this.prodColumns = result[5] || []
        this.empColumns = result[6] || []
        this.operArr = result[7] || []
        this.$nextTick(function () {
          if (this.$refs.listTable && this.$refs.listTable.doLayout) this.$refs.listTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.loading = false
      }.bind(this))
    },
    normalizeResultRows: function (res, silent) {
      var result = res && res && res.result
      if (Array.isArray(result)) return result
      if (result && !silent) this.$emit('error', String(result).split('\n')[0] || this.$LANG('1442', '提示'))
      return []
    },
    reloadAfterChange: function () {
      return this.loadRows().then(function (rows) {
        this.tableData = rows || []
        this.$emit('changed')
        this.$nextTick(function () {
          if (this.$refs.listTable && this.$refs.listTable.doLayout) this.$refs.listTable.doLayout()
        })
      }.bind(this))
    },
    loadPermission: function () {
      this.addBool = false
      this.editBool = false
      this.cfmBool = false
      this.appBool = false
      return getTabColOrData(this.tableUrl,  'v_sys_user_priv', 'userno', this.vUsername, 'frmidseq', '426315', '', '', '').then(function (res) {
        if (this.vAdmin !== 'N') return
        var rows = this.normalizeResultRows(res, true)
        var row = rows[0] || {}
        this.addBool = row.ISADD === 'N'
        this.editBool = row.ISUPD === 'N'
        this.cfmBool = row.ISCFM === 'N'
        this.appBool = row.ISEXP === 'N'
      }.bind(this))
    },
    loadRequiredFields: function () {
      return getTabColOrData(this.tableUrl,   'v_sys_form_fld', 'idseq', '426315', 'LSTSEQ', '1', 'NOTNULL', 'Y', '').then(function (res) {
        return this.normalizeResultRows(res, true).map(function (item) {
          return this.normalizeColumn(item)
        }.bind(this))
      }.bind(this))
    },
    loadListColumns: function () {
      return this.loadColumnsByForm('426315', '1')
    },
    loadProdColumns: function () {
      return this.loadColumnsByForm('412736', '3')
    },
    loadEmpColumns: function () {
      return this.loadColumnsByForm('4204', '1')
    },
    loadColumnsByForm: function (formId, lstseq, orderBy) {
      return getTabColOrData(this.tableUrl,  'v_sys_form_fld', 'idseq', formId, 'lstseq', lstseq, '', '', orderBy || ' order by sortby,lstseq').then(function (res) {
        var list = this.normalizeResultRows(res, true)
        return list.map(function (item) {
          return this.normalizeColumn(item)
        }.bind(this))
      }.bind(this))
    },
    normalizeColumn: function (item) {
      item = item || {}
      return {
        title: this.$translate.getColTitle(item, this.$store.state.lang),
        key: item.key || item.FLDNO,
        fldno: item.FLDNO || item.key,
        align: item.align || item.ALIGN,
        width: item.width || item.WIDTH,
        thide: item.THIDE || item.thide || 'N',
        fhide: item.FHIDE || item.fhide || 'N',
        edcss: item.EDCSS || item.edcss,
        disabled: item.DISABLED || item.disabled,
        dotnum: item.DOTNUM || item.dotnum,
        sortable: item.SORTABLE || item.sortable,
        notnull: item.NOTNULL || item.notnull,
        combo: item.COMBO || item.combo,
        holder: item.HOLDER || item.holder
      }
    },
    loadRows: function () {
      var payload
      try {
        payload = this.getDynamicPayload()
      } catch (error) {
        return Promise.resolve([])
      }
      return getTabColOrData(
        this.tableUrl,
    
        payload.p_table,
        payload.p_key,
        payload.p_value,
        payload.p_key2,
        payload.p_value2,
        payload.p_key3,
        payload.p_value3,
        payload.p_cond
      ).then(function (res) {
        return this.normalizeResultRows(res)
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
        return []
      }.bind(this))
    },
    loadEmployeeRows: function () {
      return getBaseData(this.tableUrl + '', 'CORPID', this.vCorpid, 'ISOUT', 'N', 'V_SYS_USER', '').then(function (res) {
        return this.normalizeResultRows(res, true)
      }.bind(this))
    },
    loadOperRows: function () {
      return getBaseData(this.noauthUrl, 'PARENTNO', '15995', '', '', 'v_sys_base', '').then(function (res) {
        return this.normalizeResultRows(res, true)
      }.bind(this))
    },
    getNodeData: function () {
      return (this.node && this.node.nodeData) || {}
    },
    getSourceOrderRow: function () {
      return (this.node && this.node.sourceOrderRow) || {}
    },
    getRequiredSourceParams: function () {
      var row = this.getNodeData()
      var params = {
        ORDNO: row.ORDNO,
        MATNO: row.MATNO,
        CORPID: row.CORPID
      }
      var missing = []
      Object.keys(params).forEach(function (key) {
        if (params[key] === undefined || params[key] === null || params[key] === '') missing.push(key)
      })
      if (missing.length) throw new Error('MISSING_SOURCE_PARAMS')
      return params
    },
    escapeQueryValue: function (value) {
      return String(value === undefined || value === null ? '' : value).trim().replace(/'/g, "''")
    },
    getDynamicPayload: function () {
      var params = this.getRequiredSourceParams()
      return {
        p_key: '',
        p_value: '',
        p_key2: 'CORPID',
        p_value2: params.CORPID,
        p_key3: '',
        p_value3: '',
        p_table: 'v_ORD_AUDIT',
        p_cond: " and lower(MATNO) like '%" + this.escapeQueryValue(params.MATNO).toLowerCase() + "%' and lower(ORDNO) like '%" + this.escapeQueryValue(params.ORDNO).toLowerCase() + "%' order by IDNO desc"
      }
    },
    getDefaultProductSelectionRow: function () {
      var nodeRow = this.getNodeData()
      var sourceRow = this.getSourceOrderRow()
      var firstValue = function (values) {
        for (var index = 0; index < values.length; index++) {
          if (values[index] !== undefined && values[index] !== null && values[index] !== '') return values[index]
        }
        return ''
      }
      return {
        IDNO: firstValue([sourceRow.ORDNO, sourceRow.IDNO, nodeRow.ORDNO]),
        MATNO: firstValue([sourceRow.MATNO, nodeRow.MATNO]),
        MATNM: firstValue([sourceRow.MATNM, sourceRow.PRDNM, nodeRow.MATNM, nodeRow.PRDNM]),
        MATDESC: firstValue([sourceRow.MATDESC, sourceRow.PRDDESC, nodeRow.MATDESC, nodeRow.PRDDESC]),
        CLNTNM: firstValue([sourceRow.CLNTNM, nodeRow.CLNTNM]),
        IDSEQ: firstValue([sourceRow.IDSEQ, nodeRow.ORD_IDSEQ, nodeRow.REFORDSEQ]),
        LSTSEQ: firstValue([sourceRow.LSTSEQ, nodeRow.ORD_LSTSEQ, nodeRow.REFORDITM]),
        ORDTYNM: firstValue([sourceRow.ORDTYNM, nodeRow.ORDTYNM]),
        QTY: firstValue([sourceRow.QTY, nodeRow.QTY]),
        SHPDTTM: firstValue([sourceRow.SHPDTTM, nodeRow.SHPDTTM])
      }
    },
    applyProductSelection: function (row) {
      row = row || {}
      Object.assign(this.mainRow, {
        ORDNO: row.IDNO,
        MATNO: row.MATNO,
        PRDNM: row.MATNM,
        PRDDESC: row.MATDESC,
        CLNTNM: row.CLNTNM,
        REFORDSEQ: row.IDSEQ,
        REFORDITM: row.LSTSEQ,
        ORDTYNM: row.ORDTYNM,
        QTY: row.QTY,
        SHPDTTM: row.SHPDTTM
      })
    },
    addRecord: function () {
      if (this.addBool) return
      var nodeRow = this.getNodeData()
      var sourceRow = this.getSourceOrderRow()
      var productRow = this.getDefaultProductSelectionRow()
      this.detailVisible = true
      this.detailLoading = true
      this.detailMode = 'create'
      this.saveFlag = false
      this.mainRow = {
        DTTM: getDate('day'),
        IDSEQ: '',
        STFG: 'N',
        LVL: '416999',
        QARESULT: '417007',
        CORPID: nodeRow.CORPID || sourceRow.CORPID || ''
      }
      if (productRow.IDNO && productRow.MATNO) this.applyProductSelection(productRow)
      this.imgData = []
      this.delImg = []
      Promise.all([
        this.loadFormGroups(),
        this.loadFormCombos()
      ]).then(function (result) {
        this.formGroups = result[0] || []
        this.comboArr = result[1] || {}
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.detailLoading = false
      }.bind(this))
    },
    openDetail: function (row, mode) {
      if (!row) return
      if (mode === 'edit' && this.editBool) return
      this.detailVisible = true
      this.detailLoading = true
      this.detailMode = mode === 'edit' ? 'edit' : 'view'
      this.saveFlag = this.detailMode !== 'edit' || row.STFG === 'Y'
      this.mainRow = JSON.parse(JSON.stringify(Object.assign({}, row, { IDSEQ: row.IDSEQ })))
      this.delImg = []
      Promise.all([
        this.loadFormGroups(),
        this.loadFormCombos(),
        this.loadImageRows(row.IDSEQ)
      ]).then(function (result) {
        this.formGroups = result[0] || []
        this.comboArr = result[1] || {}
        this.imgData = result[2] || []
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.detailLoading = false
      }.bind(this))
    },
    loadFormGroups: function () {
      return getTabColOrData(this.formGroupUrl,  'v_sys_form_fld', 'idseq', '426315', 'gpnm,gpsort', '', 'lstseq', '1', ' order by gpsort').then(function (res) {
        var groups = this.normalizeResultRows(res, true)
        return groups.map(function (group) {
          var nextGroup = Object.assign({}, group)
          nextGroup.gplist = (group.gplist || []).map(function (item) {
            return this.normalizeColumn(item)
          }.bind(this)).filter(function (item) {
            return this.isVisibleFormField(item)
          }.bind(this))
          return nextGroup
        }.bind(this)).filter(function (group) {
          return group.gplist && group.gplist.length
        })
      }.bind(this))
    },
    loadFormCombos: function () {
      return getTabColOrData(this.tableUrl, 'v_sys_form_fld', 'idseq', '426315', 'edcss', 'select', '', '', ' and lstseq in (1,2)').then(function (res) {
        var fields = this.normalizeResultRows(res, true)
        return Promise.all(fields.map(function (field) {
          return this.loadComboOptions(field)
        }.bind(this))).then(function (results) {
          var comboMap = {}
          results.forEach(function (item) {
            if (item.fldno) comboMap[item.fldno] = item.options
            if (item.key) comboMap[item.key] = item.options
          })
          return comboMap
        })
      }.bind(this))
    },
    loadComboOptions: function (field) {
      if (!field || !field.COMBO) return Promise.resolve({ fldno: field && field.FLDNO, key: field && field.key, options: [] })
      return getTabColOrData(this.noauthUrl,   'v_sys_base', 'parentno', field.COMBO, '', '', '', '', '').then(function (res) {
        return {
          fldno: field.FLDNO,
          key: field.key,
          options: this.normalizeResultRows(res, true)
        }
      }.bind(this))
    },
    loadImageRows: function (idseq) {
      if (!idseq) return Promise.resolve([])
      return getTabColOrData(this.tableUrl,  'V_mat_img', 'idseq', idseq, '', '', '', '', '').then(function (res) {
        return this.normalizeResultRows(res, true)
      }.bind(this))
    },
    getGroupLabelWidth: function (group) {
      return group && group.gpnm === this.$LANG('0843', '注意事项') ? 160 : 120
    },
    getMainFormCellClass: function (item) {
      var classes = ['order-audit-detail-dialog__form-cell']
      if (this.isTextareaField(item)) classes.push('order-audit-detail-dialog__form-cell--wide')
      if (this.isMainFieldDisabled(item)) classes.push('order-audit-detail-dialog__form-cell--disabled')
      return classes
    },
    isVisibleFormField: function (item) {
      var fhide = String((item && (item.fhide || item.FHIDE)) || 'N').toUpperCase()
      return fhide !== 'Y'
    },
    isTextareaField: function (item) {
      var edcss = String((item && (item.edcss || item.EDCSS)) || '').toLowerCase()
      var title = String((item && item.title) || '').trim()
      return edcss.indexOf('textarea') > -1 || ['产品要求', '双方有分岐的技术问题是否已解决', '工艺技术等是否可以保证'].indexOf(title.replace(/\s/g, '')) > -1
    },
    isMainFieldDisabled: function (item) {
      return this.saveFlag || (item && item.disabled === 'Y')
    },
    validateDetail: function () {
      var missingTitle = ''
      this.requiredFields.some(function (item) {
        if (!this.mainRow[item.fldno]) {
          missingTitle = item.title
          return true
        }
        return false
      }.bind(this))
      if (missingTitle) {
        this.$emit('error', missingTitle + this.$LANG('2051', '不能为空'))
        return false
      }
      return true
    },
    saveDetail: function () {
      if (this.saveFlag || this.saving) return
      if (this.detailMode === 'create' && this.addBool) return
      if (this.detailMode === 'edit' && this.editBool) return
      if (!this.validateDetail()) return
      this.saving = true
      this.$axios({
        method: 'post',
        url:  'xuper_auth/formOneSave',
        data: { p_json: JSON.stringify(Object.assign({}, this.mainRow, { CORPID: this.nodeCorpid })), p_table: 'ORD_AUDIT', frmid: '426315' }
      }).then(function (res) {
        if (res && res.result === 'OK') {
          var idseq = res.idseq
          return this.saveImageRows(idseq).then(function () {
            return this.deleteRemovedImageRows()
          }.bind(this)).then(function () {
            this.detailVisible = false
            return this.reloadAfterChange()
          }.bind(this))
        }
        this.$emit('error', (res && res.result) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.saving = false
      }.bind(this))
    },
    saveImageRows: function (idseq) {
      var promise = Promise.resolve()
      this.imgData.forEach(function (row) {
        promise = promise.then(function () {
          return this.$axios({
            method: 'post',
            url:  'xuper_auth/tableBodySave',
            data: { p_json: JSON.stringify(Object.assign({}, row)), p_table: 'mat_img', p_idseq: idseq }
          })
        }.bind(this))
      }.bind(this))
      return promise
    },
    deleteRemovedImageRows: function () {
      var promise = Promise.resolve()
      this.delImg.forEach(function (row) {
        promise = promise.then(function () {
          return this.$axios({
            method: 'post',
            url:  'xuper_auth/delTabRec',
            data: { p_key: 'idseq', p_value: row.IDSEQ, p_key2: 'lstseq', p_value2: row.LSTSEQ, p_key5: 'filepath', p_value5: row.FILEPATH, p_table: 'mat_img' }
          })
        }.bind(this))
      }.bind(this))
      return promise
    },
    setStatus: function (row, value, statusText) {
      if (!row) return
      if ((value === 'K' && row.STFG === 'N') || (value === 'N' && row.STFG === 'K')) {
        if (this.appBool) return
      } else if (this.cfmBool) {
        return
      }
      statusText = statusText || this.getStatusText(value)
      if (value === 'K' && row.FRUSER === this.vUsernm) {
        this.$emit('error', this.$LANG('1889', '提出者与确认人不能相同，请核查'))
        return
      }
      this.$confirm(this.$LANG('1564', '你确定要') + statusText + this.$LANG('1565', '此单据吗?'), this.$LANG('1442', '提示'), {
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText: this.$LANG('0132', '取消'),
        customClass: 'process-mind-map-message-box',
        showClose: false,
        type: 'info'
      }).then(function () {
        var cond = this.buildStatusCond(value)
        return this.$axios({
          method: 'post',
          url:  'xuper_auth/updateRec',
          data: { p_key: 'idseq', p_value: row.IDSEQ, p_table: 'ORD_AUDIT', p_cond: cond }
        }).then(function (res) {
          if (res && res.code === '200') return this.reloadAfterChange()
          this.$emit('error', (res && (res.message || res.result)) || this.$LANG('1442', '提示'))
        }.bind(this))
      }.bind(this)).catch(function () {})
    },
    getStatusText: function (value) {
      if (value === 'K') return this.$LANG('0364', '确认')
      if (value === 'Y') return this.$LANG('0134', '审核')
      return this.$LANG('0314', '弃认')
    },
    buildStatusCond: function (value) {
      if (value === 'K') {
        return " set stfg='K',appuser='" + this.escapeQueryValue(this.vUsernm) + "',appdttm='" + getDate('full') + "',chkuser=null,chkdttm=null"
      }
      if (value === 'Y') {
        return " set stfg='Y',chkuser='" + this.escapeQueryValue(this.vUsernm) + "',chkdttm='" + getDate('full') + "'"
      }
      return " set stfg='" + this.escapeQueryValue(value) + "',chkuser='',chkdttm='',appuser='',appdttm=''"
    },
    inputBtn: function (key) {
      if (this.saveFlag) return
      this.selectKey = key
      this.resetSelectData()
      if (key === 'MATNO') {
        this.selectColumns = this.prodColumns
        this.selectTable = 'v_orditm'
        this.selectKey2 = ''
        this.selectValue2 = ''
        this.selectUseCorpid = true
      } else {
        this.selectColumns = this.empColumns
        this.selectTable = 'v_hr_emp'
        this.selectKey2 = 'stfg'
        this.selectValue2 = 'Y'
        this.selectUseCorpid = true
      }
      this.selectVisible = true
      this.$nextTick(function () {
        this.initSelectParam()
        this.querySelectRows()
      })
    },
    resetSelectData: function () {
      this.selectParam = ''
      this.selectText = ''
      this.selectOper = 'like'
      this.selectLoading = false
      this.selectSelectedRow = {}
      this.selectRows = []
      this.selectPageRows = []
      this.selectDataCount = 0
      this.selectCurrent = 1
    },
    initSelectParam: function () {
      var firstIdColumn = this.selectVisibleColumns.filter(function (item) {
        return item.key === 'IDNO' || item.key === 'MATNO' || item.key === 'EMPNM'
      })[0]
      this.selectParam = firstIdColumn ? firstIdColumn.key : ((this.selectVisibleColumns[0] && this.selectVisibleColumns[0].key) || '')
      if (this.$refs.selectQueryInput && this.$refs.selectQueryInput.focus) this.$refs.selectQueryInput.focus()
    },
    querySelectRows: function () {
      if (!this.selectTable) return
      this.selectLoading = true
      var cond = ''
      if (this.selectParam && this.selectText) {
        if (this.selectOper === 'like') {
          cond += " and upper(" + this.selectParam + ") like upper('%" + this.escapeQueryValue(this.selectText) + "%')"
        } else {
          cond += " and upper(" + this.selectParam + ')' + this.selectOper + "upper('" + this.escapeQueryValue(this.selectText) + "')"
        }
      }
      this.$axios({
        method: 'post',
        url:  'xuper_auth/getBaseData',
        data: {
          p_key: this.selectUseCorpid ? 'corpid' : '',
          p_value: this.selectUseCorpid ? this.vCorpid : '',
          p_key2: this.selectKey2,
          p_value2: this.selectValue2,
          p_cond: cond,
          p_table: this.selectTable
        }
      }).then(function (res) {
        this.selectRows = this.normalizeResultRows(res)
        this.selectSelectedRow = {}
        this.initSelectPage()
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
        this.selectRows = []
        this.initSelectPage()
      }.bind(this)).finally(function () {
        this.selectLoading = false
        this.$nextTick(function () {
          if (this.$refs.selectTableRef && this.$refs.selectTableRef.doLayout) this.$refs.selectTableRef.doLayout()
        })
      }.bind(this))
    },
    initSelectPage: function () {
      this.selectDataCount = this.selectRows.length
      this.selectCurrent = 1
      this.changeSelectPage(1)
    },
    changeSelectPage: function (page) {
      var start = (page - 1) * this.selectRowSize
      var end = page * this.selectRowSize
      this.selectCurrent = page
      this.selectPageRows = this.selectRows.slice(start, end)
    },
    selectRowClick: function (row) {
      this.selectSelectedRow = JSON.parse(JSON.stringify(row || {}))
    },
    confirmSelectRow: function () {
      if (this.selectSelectedRow && this.selectSelectedRow.IDSEQ) {
        this.handleSelectSure(this.selectSelectedRow)
      } else {
        this.$emit('error', this.$LANG('1695', '请选择一记录'))
      }
    },
    handleSelectSure: function (obj) {
      if (this.selectKey === 'MATNO') {
        this.applyProductSelection(obj)
      } else if (this.selectKey === 'TECHEMP') {
        Object.assign(this.mainRow, { TECHEMP: obj.EMPNM })
      } else if (this.selectKey === 'PRDEMP') {
        Object.assign(this.mainRow, { PRDEMP: obj.EMPNM })
      } else if (this.selectKey === 'QAEMP') {
        Object.assign(this.mainRow, { QAEMP: obj.EMPNM })
      } else if (this.selectKey === 'POEMP') {
        Object.assign(this.mainRow, { POEMP: obj.EMPNM })
      } else if (this.selectKey === 'BIZEMP') {
        Object.assign(this.mainRow, { BIZEMP: obj.EMPNM })
      }
      this.selectVisible = false
    },
    handleNumberKeydown: function (event) {
      if (['e', 'E', '+'].indexOf(event.key) > -1) event.returnValue = false
    },
    pdfViewer: function (path) {
      var routeUrl = this.$router.resolve({
        path: '/fullPreview',
        query: { fileUrl: path }
      })
      window.open(routeUrl.href, '_blank')
    },
    imgDel: function (idseq, lstseq, path, index) {
      if (this.saveFlag) return
      this.$confirm(this.$LANG('1594', '你确定要删除此附件吗'), this.$LANG('1442', '提示'), {
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText: this.$LANG('0132', '取消'),
        customClass: 'process-mind-map-message-box',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'info'
      }).then(function () {
        this.delImg.push({ IDSEQ: idseq, LSTSEQ: lstseq, FILEPATH: path })
        this.imgData.splice(index, 1)
      }.bind(this)).catch(function () {})
    },
    handleProgress: function (event) {
      this.videoFlag = true
      this.videoUploadPercent = Math.floor(event.percent)
    },
    handleFormatError: function (file) {
      this.$emit('error', this.$LANG('1455', '文件格式错误,') + file.name + this.$LANG('1431', ' 是不正确, 请选择pdf或图片格式'))
    },
    handleMaxSize: function (file) {
      this.$emit('error', file.name + this.$LANG('1561', '文件太大， 不能超出') + '2M')
    },
    successImgFile: function (res, file) {
      this.videoUploadPercent = 0
      this.videoFlag = false
      this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result })  
    },
    beforeImgFile: function () {

      this.uploadData = { 
          p_type:'IMG',
          p_path:'/web/web_images/material/',
          p_user:this.v_username
       }
      return new Promise(function (resolve) {
        this.$nextTick(function () {
          resolve(true)
        })
      }.bind(this))
    },
    isPdfFile: function (path) {
      return String(path || '').toLowerCase().lastIndexOf('.pdf') > -1
    },
    isYesNoField: function (item) {
      return item && item.edcss === 'checkbox'
    },
    getStatusTagType: function (value) {
      if (value === 'Y') return 'success'
      if (value === 'K') return 'warning'
      if (value === 'X') return 'danger'
      return 'info'
    },
    getStatusTextForRow: function (row) {
      row = row || {}
      if (row.STFG === 'Y') return this.$LANG('1976', '已审核')
      if (row.STFG === 'K') return this.$LANG('0364', '确认')
      if (row.STFG === 'X') return this.$LANG('0257', '作废')
      return this.$LANG('2005', '未审核')
    },
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    headStyle: function (params) {
      var column = params.column || {}
      if (this.getSummaryFields().indexOf(column.property) > -1) return 'color:red'
    },
    getSummaryFields: function () {
      return ['QTY', 'PRDQTY', 'CHKQTY', 'BADQTY', 'OKQTY', 'QUALQTY', 'NOQTY', 'SZQTY', 'LOOKQTY', 'OTHQTY']
    },
    getSummary: function (param) {
      var sums = []
      var sumFields = this.getSummaryFields()
      param.columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = this.$LANG('0280', '合计')
          return
        }
        if (sumFields.indexOf(column.property) === -1) return
        var values = param.data.map(function (item) { return Number(item[column.property]) })
        var sumValue = values.reduce(function (prev, curr) {
          if (!isNaN(curr)) return Number(prev) + Number(curr)
          return prev
        }, 0)
        sums[index] = sumValue ? sumValue.toFixed(2) : ''
      }.bind(this))
      return sums
    }
  }
}
</script>

<style scoped lang="less">
.order-audit-dialog__title {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 56px 0 20px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  color: #1f2f3d;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}
.order-audit-dialog__body {
  min-height: 70vh;
}
.order-audit-dialog__toolbar {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 8px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
}
.order-audit-dialog__add {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 26px !important;
  min-height: 26px !important;
  padding: 0 10px !important;
  border-radius: 13px !important;
  font-size: 12px !important;
  line-height: 26px !important;
}
.order-audit-dialog__add i {
  margin-right: 4px !important;
  font-size: 14px !important;
  line-height: 14px !important;
}
.order-audit-dialog__table {
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
}
.order-audit-dialog__idno {
  color: #606266;
  font-size: 13px;
  font-weight: 700;
  border-bottom: 1px solid red;
}
.order-audit-dialog__action-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.order-audit-dialog__action-button {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 32px !important;
  min-width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  margin: 0 !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 50% !important;
  background: #fff !important;
  color: #409eff;
  line-height: 32px !important;
}
.order-audit-dialog__action-button.el-button--text,
.order-audit-dialog__action-button.el-button--text:hover,
.order-audit-dialog__action-button.el-button--text:focus {
  border: 1px solid #dcdfe6 !important;
}
.order-audit-dialog__action-button i,
.order-audit-dialog__action-button ::v-deep i,
.order-audit-dialog__action-button ::v-deep [class^="iconfont"],
.order-audit-dialog__action-button ::v-deep [class*=" iconfont"] {
  display: inline-block;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  font-size: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
}
.order-audit-dialog__action-button:hover,
.order-audit-dialog__action-button:focus {
  border-color: #c0c4cc !important;
  background: rgba(64, 158, 255, .1) !important;
  color: #1f78ff;
}
.order-audit-dialog__action-button.is-disabled,
.order-audit-dialog__action-button.is-disabled:hover,
.order-audit-dialog__action-button.is-disabled:focus {
  border-color: #e4e7ed !important;
  background: #f5f7fa !important;
  color: #c0c4cc !important;
}
.order-audit-detail-dialog__body {
  height: 82vh;
  padding: 14px 18px 96px;
  overflow-y: auto;
  background: #fff;
  box-sizing: border-box;
}
.order-audit-detail-dialog__section {
  margin: 8px 0 !important;
  padding: 0 2px;
}
.order-audit-detail-dialog__section--attachment {
  margin: 8px 0 !important;
}
.order-audit-detail-dialog__form {
  display: block;
  padding: 0 12px 12px;
  box-sizing: border-box;
}
.order-audit-detail-dialog__form-item {
  width: 100%;
  min-width: 0;
  margin: 0 !important;
}
.order-audit-detail-dialog__form-cell {
  display: inline-block;
  width: 32%;
  min-width: 0;
  min-height: 32px;
  margin-bottom: 16px;
  padding-right: 24px;
  vertical-align: top;
  box-sizing: border-box;
}
.order-audit-detail-dialog__form-cell--wide {
  display: block !important;
  width: 97% !important;
  min-height: 120px;
  padding-right: 0;
}
.order-audit-detail-dialog__form-item--wide {
  display: flex !important;
  width: 100% !important;
  min-height: 112px;
}
.order-audit-detail-dialog__form-item--wide .el-textarea {
  width: 100% !important;
}
.order-audit-detail-dialog__form-item--textarea {
  align-items: flex-start;
}
.order-audit-detail-dialog__form-cell:has(textarea) {
  display: block !important;
  width: 97% !important;
  min-height: 120px;
  padding-right: 0;
}
.order-audit-detail-dialog__form-cell:has(textarea) .order-audit-detail-dialog__form-item {
  display: flex !important;
  width: 100% !important;
  min-height: 112px;
  align-items: flex-start;
}
.order-audit-detail-dialog__required {
  color: red;
}
.order-audit-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
}
.order-audit-detail-dialog__status {
  min-width: 32px;
  color: red;
  font-size: 28px;
  line-height: 1;
}
.order-audit-detail-dialog__attachment-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  min-height: 170px;
  padding: 0 12px 28px;
  box-sizing: border-box;
}
.order-audit-detail-dialog__attachment-row--empty-view {
  min-height: 32px;
  padding: 0 12px 12px;
}
.order-audit-detail-dialog__uploader {
  flex: 0 0 200px;
}
.order-audit-detail-dialog__uploader ::v-deep .ivu-upload-drag {
  height: 150px;
  overflow: hidden;
  border-radius: 6px;
  box-sizing: border-box;
}
.order-audit-detail-dialog__upload-inner {
  width: 200px;
  height: 150px;
  padding: 1px 0;
  color: #515a6e;
  text-align: center;
  box-sizing: border-box;
}
.order-audit-detail-dialog__upload-img {
  width: 76px;
  height: 76px;
  margin-top: 24px;
}
.order-audit-detail-dialog__upload-inner p {
  margin: 5px 0 0;
  font-size: 12px;
}
.order-audit-detail-dialog__attachment-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
  min-height: 150px;
}
.order-audit-detail-dialog__attachment-list--empty-view {
  width: 100%;
  min-height: 32px;
}
.order-audit-detail-dialog__attachment-card {
  width: 150px;
}
.order-audit-detail-dialog__attachment-img,
.order-audit-detail-dialog__pdf-frame {
  width: 150px;
  height: 125px;
  border: 1px solid #e8eaec;
  box-sizing: border-box;
}
.order-audit-detail-dialog__pdf-frame {
  overflow: hidden;
}
.order-audit-detail-dialog__pdf-frame iframe {
  width: 100%;
  height: 100%;
}
.order-audit-detail-dialog__attachment-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 150px;
  min-height: 25px;
  padding: 0 6px;
  background: #e8eaec;
  box-sizing: border-box;
}
.order-audit-detail-dialog__empty {
  display: flex;
  align-items: center;
  width: 100%;
  height: 32px;
  min-height: 32px;
  padding: 0 12px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  background: #f9fafc;
  color: #909399;
  font-size: 13px;
  line-height: 32px;
  box-sizing: border-box;
}
.order-audit-select-dialog__body {
  height: 82vh;
  overflow: hidden;
  background: #fff;
}
.order-audit-select-dialog__toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 10px;
  border-bottom: 2px solid #389;
  box-sizing: border-box;
}
.order-audit-select-dialog__label {
  flex: 0 0 auto;
  color: #606266;
  font-size: 12px;
  line-height: 32px;
}
.order-audit-select-dialog__field {
  width: 170px;
}
.order-audit-select-dialog__oper {
  width: 110px;
}
.order-audit-select-dialog__input {
  width: 280px;
}
.order-audit-select-dialog__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
}
.order-audit-select-dialog__actions .el-button + .el-button {
  margin-left: 0;
}
.order-audit-select-dialog__table {
  width: 100%;
}
.order-audit-select-dialog__pager {
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 8px;
  background: #fff;
  box-sizing: border-box;
}
.order-audit-upload-progress__title {
  min-height: 30px;
  padding-left: 5px;
  background: #409eff;
  color: #fff;
  font-size: 16px;
  line-height: 30px;
}
</style>

<style lang="less">
.process-mind-map-dialog.order-audit-list-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 10px;
  }
  .custom-table-border .el-table__body td,
  .custom-table-border .el-table__header th {
    border-color: rgb(184, 181, 181);
    border-width: 1px;
  }
}
.process-mind-map-dialog.order-audit-detail-dialog,
.process-mind-map-dialog.order-audit-select-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;
    border-radius: 8px;
    .el-dialog__body {
      position: absolute;
      left: 0;
      right: 0;
      top: 40px;
      bottom: 0;
      padding: 0;
      overflow: hidden;
    }
  }
  .el-dialog__header {
    padding: 0;
  }
  .custom-table-border .el-table__body td,
  .custom-table-border .el-table__header th {
    border-color: rgb(184, 181, 181);
    border-width: 1px;
  }
}
.process-mind-map-dialog.order-audit-detail-dialog {
  .el-dialog__body {
    bottom: 54px !important;
  }
  .order-audit-detail-dialog__form {
    .ivu-form-item {
      margin-bottom: 0 !important;
    }
    .ivu-form-item-label {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      height: 32px;
      width: 120px;
      padding: 0 12px 0 0;
      line-height: 32px;
      text-align: right;
      box-sizing: border-box;
      vertical-align: top;
    }
    .ivu-form-item-content {
      min-height: 32px;
      line-height: 32px;
    }
    .order-audit-detail-dialog__form-item--wide .ivu-form-item-content {
      flex: 1 1 auto;
      width: auto !important;
      min-width: 0;
      margin-left: 0 !important;
      line-height: 1.4;
    }
    .order-audit-detail-dialog__form-item--textarea .ivu-form-item-label {
      align-items: flex-start !important;
      height: auto !important;
      min-height: 96px !important;
      padding-top: 0 !important;
      line-height: 24px !important;
      white-space: normal !important;
      word-break: break-all;
    }
    .order-audit-detail-dialog__form-item--textarea .el-textarea,
    .order-audit-detail-dialog__form-item--textarea .el-textarea__inner {
      min-height: 96px !important;
      line-height: 20px !important;
    }
    .order-audit-detail-dialog__form-cell:has(textarea) .ivu-form-item-content {
      flex: 1 1 auto;
      width: auto !important;
      min-width: 0;
      margin-left: 0 !important;
      line-height: 1.4;
    }
    .order-audit-detail-dialog__form-cell:has(textarea) .ivu-form-item-label {
      align-items: flex-start !important;
      height: auto !important;
      min-height: 96px !important;
      padding-top: 0 !important;
      line-height: 24px !important;
      white-space: normal !important;
      word-break: break-all;
    }
    .order-audit-detail-dialog__form-cell:has(textarea) .el-textarea,
    .order-audit-detail-dialog__form-cell:has(textarea) .el-textarea__inner {
      width: 100% !important;
      min-height: 96px !important;
      line-height: 20px !important;
    }
    .el-input,
    .el-select,
    .el-date-editor,
    .el-input-number {
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input__inner,
    .el-input--medium .el-input__inner,
    .el-select .el-input__inner,
    .el-date-editor .el-input__inner,
    .el-input-number .el-input__inner {
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input.is-disabled .el-input__inner,
    .el-textarea.is-disabled .el-textarea__inner,
    .el-input__inner[disabled],
    .el-textarea__inner[disabled] {
      border-color: #dcdfe6 !important;
      background-color: #f5f7fa !important;
      color: #909399 !important;
      cursor: not-allowed !important;
    }
    .el-select .el-input.is-disabled .el-input__inner,
    .el-date-editor.el-input.is-disabled .el-input__inner,
    .el-input-number.is-disabled .el-input__inner {
      border-color: #dcdfe6 !important;
      background-color: #f5f7fa !important;
      color: #909399 !important;
      cursor: not-allowed !important;
    }
    .el-input__icon {
      line-height: 32px !important;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 32px;
      height: 30px !important;
      line-height: 30px !important;
    }
    .el-input-number .el-input__inner {
      padding-left: 36px;
      padding-right: 36px;
    }
    .order-audit-detail-dialog__form-cell {
      .el-input.el-input--medium,
      .el-select.el-select--medium,
      .el-date-editor.el-input.el-input--medium,
      .el-input-number.el-input-number--medium {
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        line-height: 32px !important;
        vertical-align: top !important;
      }
      .el-input.el-input--medium .el-input__inner,
      .el-select.el-select--medium .el-input.el-input--medium .el-input__inner,
      .el-date-editor.el-input.el-input--medium .el-input__inner,
      .el-input-number.el-input-number--medium .el-input.el-input--medium .el-input__inner {
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        line-height: 32px !important;
        box-sizing: border-box !important;
      }
      .el-input-number.el-input-number--medium {
        display: inline-flex !important;
        align-items: center !important;
      }
      .el-input-number.el-input-number--medium .el-input {
        display: block !important;
        height: 32px !important;
        line-height: 32px !important;
      }
      .el-input-number.el-input-number--medium .el-input__inner {
        padding-right: 36px !important;
        padding-left: 36px !important;
        vertical-align: top !important;
      }
      .el-input-number.el-input-number--medium .el-input-number__decrease,
      .el-input-number.el-input-number--medium .el-input-number__increase {
        top: 1px !important;
        width: 32px !important;
        height: 30px !important;
        line-height: 30px !important;
      }
    }
    .el-input-number.is-disabled .el-input-number__decrease,
    .el-input-number.is-disabled .el-input-number__increase {
      border-color: #dcdfe6 !important;
      background-color: #f5f7fa !important;
      color: #c0c4cc !important;
      cursor: not-allowed !important;
    }
    .order-audit-detail-dialog__form-cell--disabled {
      .el-input__inner,
      .el-textarea__inner,
      .el-input-number__decrease,
      .el-input-number__increase {
        border-color: #dcdfe6 !important;
        background-color: #f5f7fa !important;
        color: #909399 !important;
        cursor: not-allowed !important;
      }
      .el-input,
      .el-select,
      .el-date-editor,
      .el-input-number {
        color: #909399 !important;
      }
      .el-input__prefix,
      .el-input__suffix,
      .el-input__icon,
      .el-select__caret {
        color: #c0c4cc !important;
      }
    }
  }
  .el-dialog__footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 54px;
    padding: 10px 18px;
    border-top: 1px solid #dcdfe6;
    background: #fff;
    box-sizing: border-box;
  }
}
.process-mind-map-dialog.order-audit-select-dialog {
  .el-dialog__body {
    bottom: 0;
  }
}
</style>
